export default {
    namespaced: true,
    state: {
        primaryTreatments: [9, 10, 11, 15, 26], // this.$store.state.simplePlan.primaryTreatments
        selectedGroup: null,
        selectedGroupIndex: -1,
        rootItem: 0,
        crownItem: 0,
        rootCount: 0,
        crownCount: 0,
        range: [2, 6],
        extraTotal: 0,
        upperJawTotal: 0,
        lowerJawTotal: 0,
        upperJawTitle: "",
        lowerJawTitle: "",
        activeTreatmentPid: 0,
        activeToothNumbers: [], // this.$store.state.simplePlan.activeToothNumbers
        treatedToothNumbers: [],
        blinking: false,

        upperTpl: null, // Full jaw treatment in the upper jaw
        lowerTpl: null, // Full jaw treatment in the lower jaw
        availableTreatmentPids: [],
        allowImplantRecalc: false,

        selectedRegion: -1, // this.$store.state.simplePlan.selectedRegion
        selectedJaw: "", // this.$store.state.simplePlan.selectedJaw
        steps: [],
        extraSteps: [],
        status: [],
        jawRange: [0, 0],
        openSelectedDetails: false,
        blinkingToothId: 0,
        currency: '',
        tutorialMode: false, // TODO: it should be on reset?

        discountMode: "percentage",
        discountAmount: 0,

        fullTotal: 0,
    },
    getters: {
        totalForJaw(state, getters, rootState, rootGetters) {
            return (jaw, withExtras = true) => {
                let total = 0;
                // eslint-disable-next-line no-console
                if (!["upper", "lower"].includes(jaw)) return 0;
                state.steps.forEach((step) => {
                    if (step.jaw !== jaw) return;
                    if (step.tooth_id === "0" || step.tooth_id === "") return false;
                    if (typeof step.options !== "undefined" && step.options.length > 0) {
                        step.options.forEach((option) => {
                            if (parseInt(option.selected) === 0) return;
                            total += isNaN(parseFloat(option.price)) ? 0 : parseFloat(option.price);
                        });
                    } else {
                        total += isNaN(parseFloat(step.price)) ? 0 : parseFloat(step.price);
                    }
                });

                if (withExtras) {
                    state.extraSteps.forEach((step) => {
                        if (step.jaw !== jaw) return;
                        if (step.tooth_id === "0" || step.tooth_id === "") return false;
                        total += step.unit_price * step.amount;
                    });
                }

                return total;
            };
        },
        regionItems(state, getters, rootState, rootGetters) {
            if (state.selectedGroup === null) return [];
            const teethIds = getters.getTeethIds;
            const start = teethIds.indexOf(state.selectedGroup.range[0]);
            const end = teethIds.indexOf(state.selectedGroup.range[1]) + 1;
            return teethIds.slice(start, end);
        },
        getTeethIds(state, getters, rootState, rootGetters) {
            if (state.selectedGroup === null) return [];
            const teethIdsUpper = [17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27];
            const teethIdsLower = [47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37];
            return (state.selectedGroup.selectedRegion < 3) ? teethIdsUpper : teethIdsLower;
        },
    },
    mutations: {
        reset: (state, value) => {
            state.selectedRegion = -1;
            state.selectedJaw = "";
            state.upperTpl = null, // Full jaw treatment in the upper jaw
            state.lowerTpl = null, // Full jaw treatment in the lower jaw
            state.availableTreatmentPids = [];
            state.allowImplantRecalc = [],
            state.steps.splice(0, state.steps.length);
            state.status.splice(0, state.status.length);
            state.extraSteps.splice(0, state.extraSteps.length);
            state.jawRange = [0, 0];
            state.activeTreatmentPid = 0,
            state.activeToothNumbers.splice(0, state.steps.length);
            state.upperJawTitle = "";
            state.lowerJawTitle = "";
            state.upperJawTotal = 0;
            state.lowerJawTotal = 0;
            state.extraTotal = 0;
            state.treatedToothNumbers.splice(0, state.treatedToothNumbers.length);
            state.blinking = false;
            state.openSelectedDetails = false;
            state.blinkingToothId = 0;
            state.discountMode = "percentage";
            state.discountAmount = 0;
            state.fullTotal = 0;
        },
        changeTutorialMode(state, payload) {
            state.tutorialMode = payload;
        },
    },
};
